import { useQuery } from "@tanstack/react-query";
import URLS from "@api/constants/urls";
import { useState } from "react";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { IGetServiceProps } from "@api/types/globalService.types";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";

export const useGetAllGeoScopeService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const allGeoScopeService = useQuery({
    queryKey: [
      CACHE_KEYS.GEO_SCOPE,
      debouncedQuery,
      searchQuery,
      page,
      per_page,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.GEO_SCOPES,
        searchParams: {
          page,
          "filter[name]": debouncedQuery,
          per_page,
        },
      }),
    enabled: enableQuery,
  });
  return {
    service: { allGeoScopeService },
    states: { searchQuery, setSearchQuery },
  };
};
